/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import {
  Typography,
  Grid,
  Paper,
  Button,
  TextField,
  Modal,
  Fade,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import { MdContentCopy } from "react-icons/md";
import ClaimCard from "./ClaimCard";
import votBox from "../../assets/votBox.png";
import { ethers } from "ethers";
import { useStylesDark, useStylesLight } from "../../Styles/ClaimPageStyles";
import { tokenOptions } from "../Auction/tokenOptions";
import { ref, onValue } from "firebase/database";
import {
  merkleAddressEthereum,
  merkleABI,
  addressRegistryABI,
  addressRegistryAddress,
} from "../../constants";
import AccountDetails from "./AccountDetails";
import UserIncentivesAccordion from "../Auction/Components/UserIncentivesAccordion";
var _ = require("lodash");

const ClaimPage = (props) => {
  const classesLight = useStylesLight();
  const classesDark = useStylesDark();
  const [classes, setClasses] = useState(classesDark);
  const [claimArray, setClaimArray] = useState([]);
  const [checkboxArray, setCheckboxArray] = useState([]);
  const [stringArray, setStringArray] = useState([]);
  const [filteredClaimArray, setFilteredClaimArray] = useState([]);
  const [claimButtonDisabled, setClaimButtonDisabled] = useState(true);
  const [claimText, setClaimText] = useState(
    "Select 2 or more tokens to claim simultaneously"
  );
  const [disableAllButtons, setDisableAllButtons] = useState(false);
  const [nothingToClaim, setNothingToClaim] = useState(undefined);
  const [nothingToClaimText, setNothingToClaimText] = useState(
    "You have no $vlCVX rewards to claim"
  );
  const [forwardedToText, setForwardedToText] = useState("");
  const [freezeClaims, setFreezeClaims] = useState(false);
  const resolvedRef = useRef(new Set());
  const [resolvedCount, setResolvedCount] = useState(0);

  const reportResolved = (index) => {
    if (!resolvedRef.current.has(index)) {
      resolvedRef.current.add(index);
      setResolvedCount(resolvedRef.current.size);
    }
  };

  // theme setting
  useEffect(() => {
    if (props.ctheme === "light") {
      setClasses(classesLight);
    } else {
      setClasses(classesDark);
    }
  }, [props.ctheme]);

  // check if claims are frozen in db
  useEffect(() => {
    const frozenRef = ref(props.db, "frozen");
    onValue(frozenRef, (snapshot) => {
      if (snapshot.val() === true) {
        setFreezeClaims(true);
      } else {
        setFreezeClaims(false);
      }
    });
  }, [props.db]);

  useEffect(() => {
    let checkboxArray = [];
    tokenOptions.map(() => {
      checkboxArray.push(false);
    });
    setCheckboxArray(checkboxArray);
  }, []);

  useEffect(() => {
    setClaimArray([]);
    setNothingToClaim(undefined);
    resolvedRef.current = new Set();
    setResolvedCount(0);
  }, [props.address]);

  // Loading until every card has fetched its DB data AND finished its on-chain
  // "already claimed" check, so claimed cards don't briefly flash as claimable.
  const claimsLoading =
    props.provider &&
    props.address &&
    resolvedCount < tokenOptions.length;

  // Safety fallback: never keep the spinner up indefinitely if a card stalls.
  useEffect(() => {
    if (!props.provider || !props.address) return;
    const timeout = setTimeout(() => {
      tokenOptions.forEach((_, i) => reportResolved(i));
    }, 20000);
    return () => clearTimeout(timeout);
  }, [props.provider, props.address]);

  useEffect(() => {
    let i = 0;
    let empty = 0;
    while (i < claimArray.length) {
      if (claimArray[i][0] === undefined) {
        empty++;
      } else {
        break;
      }
      i++;
    }
    if (empty === claimArray.length && claimArray.length !== 0) {
      setNothingToClaim(true);
      setNothingToClaimText("You have no $vlCVX rewards to claim");
    } else {
      if (props.provider) {
        setNothingToClaim(false);
      } else {
        setNothingToClaim(true);
        setNothingToClaimText(
          "Please connect your wallet to see your Votium information and claimable rewards"
        );
      }
    }
  }, [claimArray, props.provider, props.address]);

  const addToClaimArray = (res) => {
    setClaimArray((prev) => [...prev, res]);
  };

  const handleCheckboxChange = (i, bool) => {
    let newCheckboxArray = checkboxArray;
    newCheckboxArray[i] = bool;
    setCheckboxArray(newCheckboxArray);
    setStringArray(JSON.stringify(checkboxArray));
  };

  const handleClaimMulti = async () => {
    const signer = props.provider.getSigner();
    const merkleContract = new ethers.Contract(
      merkleAddressEthereum,
      merkleABI,
      signer
    );
    try {
      const tx = await merkleContract.claimMulti(
        props.address,
        filteredClaimArray
      );
      await tx.wait();
    } catch {
      console.log("Couldn't claim all - try single claiming");
    }
  };

  //splice filtered claim array
  useEffect(() => {
    let claimArrayClone = claimArray;
    let selectedClaimArray = [];
    let i = 0;
    while (i < checkboxArray.length) {
      if (checkboxArray[i] === true) {
        selectedClaimArray.push(claimArrayClone[i]);
      }
      i++;
    }

    if (selectedClaimArray.length > 0) {
      console.log(selectedClaimArray);
    }
    //console.log(claimArrayClone);
    setFilteredClaimArray(selectedClaimArray);
    if (selectedClaimArray.length > 1) {
      setClaimButtonDisabled(false);
      setDisableAllButtons(true);
      setClaimText("Claim " + selectedClaimArray.length.toString() + " tokens");
    } else {
      setClaimButtonDisabled(true);
      setDisableAllButtons(false);
      setClaimText(
        "Claim a reward, or select 2 or more tokens to claim at once"
      );
    }
  }, [stringArray, claimArray]);

  return (
    <>
      <Grid
        container
        direction="column"
        className={classes.auctionsContainer}
        justifyContent="center"
      >
        {freezeClaims ? (
          <>
            <Paper className={classes.auctionCard}>
              <Grid container direction="column" justifyContent="center">
                <Grid item>
                  <Typography className={classes.noActiveAuctionTitle}>
                    Claims are currently being updated and will be posted
                    shortly
                  </Typography>
                </Grid>
                <Grid item>
                  <img
                    src={votBox}
                    alt="time-icon"
                    className={classes.votBox}
                  ></img>
                </Grid>
              </Grid>
            </Paper>
          </>
        ) : (
          <>
            <>
              <AccountDetails
                ctheme={props.ctheme}
                forwardedToText={forwardedToText}
                db={props.db}
                address={props.address}
                provider={props.provider}
                delegateAddress={props.delegateAddress}
                refreshDelegation={props.refreshDelegation}
                connect={props.connect}
              />
              <UserIncentivesAccordion
                ctheme={props.ctheme}
                db={props.db}
                address={props.address}
                provider={props.provider}
              />
              <span className={classes.userIncentivesAccordion}></span>
              {nothingToClaim === false && !claimsLoading && (
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  display="flex"
                  className={classes.claimContainer}
                >
                  <Grid item>
                    <Button
                      onClick={handleClaimMulti}
                      classes={{
                        root: classes.submitButton,
                        disabled: classes.submitButtonDisabled,
                      }}
                      disabled={claimButtonDisabled}
                    >
                      {claimText}
                    </Button>
                  </Grid>
                </Grid>
              )}
            </>

            <div style={{ display: "flex", flexDirection: "column" }}>
              {claimsLoading && (
                <Paper className={classes.claimsLoadingCard}>
                  <Grid container direction="column" alignItems="center">
                    <CircularProgress size={28} className={classes.claimsLoadingSpinner} />
                    <Typography className={classes.claimsLoadingText}>
                      Loading claimable rewards…
                    </Typography>
                  </Grid>
                </Paper>
              )}
              <div
                style={{
                  display: claimsLoading ? "none" : "flex",
                  flexDirection: "column",
                }}
              >
                {tokenOptions.map((token, currIndex) => (
                  <ClaimCard
                    key={`${token.value}-${props.address || "none"}`}
                    token={token}
                    db={props.db}
                    address={props.address}
                    provider={props.provider}
                    addToClaimArray={addToClaimArray}
                    reportResolved={reportResolved}
                    checkboxIndex={currIndex}
                    handleCheckboxChange={handleCheckboxChange}
                    disableButton={disableAllButtons}
                    ctheme={props.ctheme}
                  />
                ))}
              </div>
            </div>
            {!claimsLoading && nothingToClaim === true && (
              <Paper className={classes.auctionCard}>
                <Grid container direction="column" justifyContent="center">
                  <Grid item style={{ margin: "1em" }}>
                    <Typography className={classes.noActiveAuctionText}>
                      {nothingToClaimText}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            )}
          </>
        )}
      </Grid>
    </>
  );
};

export default ClaimPage;
